import React from "react";

export default function Support() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.6665 15.5297V13.1297C4.3265 12.9564 1.6665 10.1831 1.6665 6.80306C1.6665 3.30973 4.5065 0.469727 7.99984 0.469727C11.4932 0.469727 14.3332 3.30973 14.3332 6.80306C14.3332 10.1031 12.0398 13.4231 8.61984 15.0697L7.6665 15.5297ZM7.99984 1.80306C5.23984 1.80306 2.99984 4.04306 2.99984 6.80306C2.99984 9.56306 5.23984 11.8031 7.99984 11.8031H8.99984V13.3364C11.4265 11.8031 12.9998 9.28306 12.9998 6.80306C12.9998 4.04306 10.7598 1.80306 7.99984 1.80306ZM7.33317 9.46973H8.6665V10.8031H7.33317V9.46973ZM8.6665 8.46973H7.33317C7.33317 6.30306 9.33317 6.46973 9.33317 5.13639C9.33317 4.40306 8.73317 3.80306 7.99984 3.80306C7.2665 3.80306 6.6665 4.40306 6.6665 5.13639H5.33317C5.33317 3.66306 6.5265 2.46973 7.99984 2.46973C9.47317 2.46973 10.6665 3.66306 10.6665 5.13639C10.6665 6.80306 8.6665 6.96973 8.6665 8.46973Z"
        fill="#0C6980"
      />
    </svg>
  );
}
